export enum EnumLevelType {
  LEVEL = 'LEVEL',
  BASEMENT = 'BASEMENT'
}

export const NAMES_LEVEL_TYPE = {
  [EnumLevelType.LEVEL]: 'Nivel',
  [EnumLevelType.BASEMENT]: 'Sótano'
}

export const CATALOG_LEVEL_TYPE = [
  { label: 'Nivel', value: EnumLevelType.LEVEL },
  { label: 'Sótano', value: EnumLevelType.BASEMENT }
]

// Defaults históricos: los parqueos se asumían en sótano y las bodegas en nivel.
// Las negociaciones que aún no tienen el dato heredan estos valores (editables).
export const DEFAULT_PARKING_LEVEL_TYPE = EnumLevelType.BASEMENT
export const DEFAULT_BASEMENT_LEVEL_TYPE = EnumLevelType.LEVEL

export const getLevelTypeName = (
  code?: string,
  fallback: EnumLevelType = EnumLevelType.LEVEL
): string => NAMES_LEVEL_TYPE[code as EnumLevelType] ?? NAMES_LEVEL_TYPE[fallback]
